import fetchServer from "../helpers/api/fetchServer";

export const createLineItem = async ({
  campaignId,
  offerId,
  name,
  clientBudget,
  realBudget,
  startDate,
  endDate,
  timezone,
  shouldSendEmailAtStart,
  hasPrimaryGoal,
  primaryGoalMetricId,
  primaryGoalRealPrice,
  hasSecondaryGoal,
  secondaryGoalMetricId,
  secondaryGoalRealPrice,
}) => {
  const method = "POST";
  const urlAPI = "/api/lineItems";
  const body = {
    campaignId,
    offerId,
    name,
    clientBudget,
    realBudget,
    startDate,
    endDate,
    timezone,
    shouldSendEmailAtStart,
    hasPrimaryGoal,
    primaryGoalMetricId,
    primaryGoalRealPrice,
    hasSecondaryGoal,
    secondaryGoalMetricId,
    secondaryGoalRealPrice,
  };
  return await fetchServer({ method, urlAPI, body });
};

export const getPaginatedLineItems = async ({
  filterText,
  filterStartDate,
  filterEndDate,
  filterAdvertiser,
  filterBrand,
  filterPlatform,
  filterAdFormat,
  filterCountry,
  filterDeleted,
  sortBy,
  page,
  nbDocsPerPage,
}) => {
  const method = "GET";
  let urlAPI = "/api/lineItems?";
  // Filters
  if (filterText) {
    if (urlAPI.slice(-1) !== "?") {
      urlAPI += "&";
    }
    urlAPI += `text=${filterText}`;
  }
  if (filterStartDate) {
    if (urlAPI.slice(-1) !== "?") {
      urlAPI += "&";
    }
    urlAPI += `startDate=${filterStartDate}`;
  }
  if (filterEndDate) {
    if (urlAPI.slice(-1) !== "?") {
      urlAPI += "&";
    }
    urlAPI += `endDate=${filterEndDate}`;
  }
  if (filterAdvertiser) {
    if (urlAPI.slice(-1) !== "?") {
      urlAPI += "&";
    }
    urlAPI += `advertiser=${filterAdvertiser}`;
  }
  if (filterBrand) {
    if (urlAPI.slice(-1) !== "?") {
      urlAPI += "&";
    }
    urlAPI += `brand=${filterBrand}`;
  }
  if (filterPlatform) {
    if (urlAPI.slice(-1) !== "?") {
      urlAPI += "&";
    }
    urlAPI += `platform=${filterPlatform}`;
  }
  if (filterAdFormat) {
    if (urlAPI.slice(-1) !== "?") {
      urlAPI += "&";
    }
    urlAPI += `adFormat=${filterAdFormat}`;
  }
  if (filterCountry) {
    if (urlAPI.slice(-1) !== "?") {
      urlAPI += "&";
    }
    urlAPI += `country=${filterCountry}`;
  }
  if (filterDeleted) {
    if (urlAPI.slice(-1) !== "?") {
      urlAPI += "&";
    }
    urlAPI += `deleted=${filterDeleted}`;
  }
  // Sort by
  if (urlAPI.slice(-1) !== "?") {
    urlAPI += "&";
  }

  urlAPI += `sortBy=${sortBy}`;

  // Pagination
  urlAPI += `&page=${page}&nbDocsPerPage=${nbDocsPerPage}`;

  return await fetchServer({ method, urlAPI });
};

export const getLineItemsByCampaign = async (campaignId) => {
  const method = "GET";
  const urlAPI = `/api/lineItems?campaign=${campaignId}`;
  return await fetchServer({ method, urlAPI });
};

export const getLineItemsByOffer = async (offerId) => {
  const method = "GET";
  const urlAPI = `/api/lineItems?offer=${offerId}`;
  return await fetchServer({ method, urlAPI });
};

export const getLineItem = async (id) => {
  const method = "GET";
  const urlAPI = `/api/lineItems/${id}`;
  return await fetchServer({ method, urlAPI });
};

export const getLineItemStatsByDay = async (id) => {
  const method = "GET";
  const urlAPI = `/api/lineItems/${id}/statsByDay`;
  return await fetchServer({ method, urlAPI });
};

export const getLineItemStatsByAdSet = async (id) => {
  const method = "GET";
  const urlAPI = `/api/lineItems/${id}/statsByAdSet`;
  return await fetchServer({ method, urlAPI });
};

export const getLineItemStatsByAd = async (id) => {
  const method = "GET";
  const urlAPI = `/api/lineItems/${id}/statsByAd`;
  return await fetchServer({ method, urlAPI });
};

export const getLineItemStatsByDevice = async (id) => {
  const method = "GET";
  const urlAPI = `/api/lineItems/${id}/statsByDevice`;
  return await fetchServer({ method, urlAPI });
};

export const getLineItemStatsByDevicePlatform = async (id) => {
  const method = "GET";
  const urlAPI = `/api/lineItems/${id}/statsByDevicePlatform`;
  return await fetchServer({ method, urlAPI });
};

export const getLineItemStatsByPlatform = async (id) => {
  const method = "GET";
  const urlAPI = `/api/lineItems/${id}/statsByPlatform`;
  return await fetchServer({ method, urlAPI });
};

export const getLineItemStatsByPlacement = async (id) => {
  const method = "GET";
  const urlAPI = `/api/lineItems/${id}/statsByPlacement`;
  return await fetchServer({ method, urlAPI });
};

export const getLineItemStatsByAge = async (id) => {
  const method = "GET";
  const urlAPI = `/api/lineItems/${id}/statsByAge`;
  return await fetchServer({ method, urlAPI });
};

export const getLineItemStatsByGender = async (id) => {
  const method = "GET";
  const urlAPI = `/api/lineItems/${id}/statsByGender`;
  return await fetchServer({ method, urlAPI });
};

export const getLineItemDataCheck = async (id) => {
  const method = "GET";
  const urlAPI = `/api/lineItems/${id}/dataCheck`;
  return await fetchServer({ method, urlAPI });
};

export const updateLineItem = async ({
  id,
  campaignId,
  offerId,
  name,
  clientBudget,
  realBudget,
  startDate,
  endDate,
  timezone,
  shouldSendEmailAtStart,
  hasPrimaryGoal,
  primaryGoalMetricId,
  primaryGoalRealPrice,
  hasSecondaryGoal,
  secondaryGoalMetricId,
  secondaryGoalRealPrice,
}) => {
  const method = "PUT";
  const urlAPI = `/api/lineItems/${id}`;
  const body = {
    campaignId,
    offerId,
    name,
    clientBudget,
    realBudget,
    startDate,
    endDate,
    timezone,
    shouldSendEmailAtStart,
    hasPrimaryGoal,
    primaryGoalMetricId,
    primaryGoalRealPrice,
    hasSecondaryGoal,
    secondaryGoalMetricId,
    secondaryGoalRealPrice,
  };

  return await fetchServer({ method, urlAPI, body });
};

export const updateLineItemAssets = async ({
  id,
  assetsType,
  assetsUrl,
  videoDuration,
  scheduledPostDate,
  postUrl,
  postPlacementIds,
  creator,
  creatorAdCode,
  wordings,
  clickUrl,
  callToActionId,
  assetsComment,
  areAssetsValid,
  videos,
  carousels,
}) => {
  const method = "PUT";
  const urlAPI = `/api/lineItems/${id}/assets`;

  const body = {
    assetsType,
    assetsUrl,
    videoDuration,
    scheduledPostDate,
    postUrl,
    postPlacementIds,
    creator,
    creatorAdCode,
    wordings,
    clickUrl,
    callToActionId,
    assetsComment,
    areAssetsValid,
    // IMPORTANT: videos only contain metadata; each version should have { key, url, size, duration, width, height, ratio, placements }
    videos,
    carousels,
  };

  return await fetchServer({ method, urlAPI, body });
};

/*
OLD CODE

export const updateLineItemAssetsOld = async ({
  id,
  assetsType,
  assetsUrl,
  videoDuration,
  scheduledPostDate,
  postUrl,
  postPlacements,
  creator,
  creatorAdCode,
  wordings,
  clickUrl,
  callToActionId,
  assetsComment,
  areAssetsValid,
  videos,
  carousels,
}) => {
  const urlAPI = `/api/lineItems/${id}/assets`;

  const formData = new FormData();
  formData.append("assetsType", assetsType);
  formData.append("assetsUrl", assetsUrl);
  formData.append("videoDuration", videoDuration);
  formData.append("scheduledPostDate", scheduledPostDate);
  formData.append("postUrl", postUrl);
  postPlacements.forEach((placement) => {
    formData.append("postPlacements", placement.id);
  });
  formData.append("creator", creator);
  formData.append("creatorAdCode", creatorAdCode);
  formData.append("wordings", JSON.stringify(wordings));
  formData.append("clickUrl", clickUrl);
  formData.append("callToActionId", callToActionId);
  formData.append("assetsComment", assetsComment);
  formData.append("areAssetsValid", areAssetsValid);
  
  videos.forEach((video, videoIndex) => {
    video.versions.forEach((version, versionIndex) => {
      // Append video file
      if (version.file) {
        formData.append(
          `videos[${videoIndex}][versions][${versionIndex}]`,
          version.file
        );
      }
      // Append metadata
      formData.append(
        `videoMetadata[${videoIndex}][versions][${versionIndex}][url]`,
        version.url
      );
      formData.append(
        `videoMetadata[${videoIndex}][versions][${versionIndex}][key]`,
        version.key
      );
      formData.append(
        `videoMetadata[${videoIndex}][versions][${versionIndex}][size]`,
        version.size
      );
      formData.append(
        `videoMetadata[${videoIndex}][versions][${versionIndex}][duration]`,
        version.duration
      );
      formData.append(
        `videoMetadata[${videoIndex}][versions][${versionIndex}][width]`,
        version.width
      );
      formData.append(
        `videoMetadata[${videoIndex}][versions][${versionIndex}][height]`,
        version.height
      );
      formData.append(
        `videoMetadata[${videoIndex}][versions][${versionIndex}][ratio]`,
        version.ratio
      );
      version.placements.forEach((placement, placementIndex) => {
        formData.append(
          `videoMetadata[${videoIndex}][versions][${versionIndex}][placements][${placementIndex}]`,
          placement.id
        );
      });
    });
  });

  carousels.forEach((carousel, carouselIndex) => {
    carousel.slides.forEach((slide, slideIndex) => {
      // Append image file
      if (slide.file) {
        formData.append(
          `carousels[${carouselIndex}][slides][${slideIndex}]`,
          slide.file
        );
      }
      // Append metadata
      formData.append(
        `carouselMetadata[${carouselIndex}][slides][${slideIndex}][url]`,
        slide.url
      );
      formData.append(
        `carouselMetadata[${carouselIndex}][slides][${slideIndex}][key]`,
        slide.key
      );
      formData.append(
        `carouselMetadata[${carouselIndex}][slides][${slideIndex}][size]`,
        slide.size
      );
      formData.append(
        `carouselMetadata[${carouselIndex}][slides][${slideIndex}][width]`,
        slide.width
      );
      formData.append(
        `carouselMetadata[${carouselIndex}][slides][${slideIndex}][height]`,
        slide.height
      );
      formData.append(
        `carouselMetadata[${carouselIndex}][slides][${slideIndex}][ratio]`,
        slide.ratio
      );
      formData.append(
        `carouselMetadata[${carouselIndex}][slides][${slideIndex}][position]`,
        slide.position
      );
    });
    carousel.placements.forEach((placement, placementIndex) => {
      formData.append(
        `carouselMetadata[${carouselIndex}][placements][${placementIndex}]`,
        placement.id
      );
    });
    if (carousel.music) {
      // Append music file
      if (carousel.music.file) {
        formData.append(
          `musics[${carouselIndex}][music]`,
          carousel.music.file
        );
      }
      // Append metadata
      formData.append(
        `carouselMetadata[${carouselIndex}][music][url]`,
        carousel.music.url
      );
      formData.append(
        `carouselMetadata[${carouselIndex}][music][key]`,
        carousel.music.key
      );
      formData.append(
        `carouselMetadata[${carouselIndex}][music][size]`,
        carousel.music.size
      );
      formData.append(
        `carouselMetadata[${carouselIndex}][music][duration]`,
        carousel.music.duration
      );
    }
  });

  return await fetchServerUpdateImage({ urlAPI, formData });
};

*/

export const updateLineItemWorkflow = async ({
  id,
  shouldSendEmailAtStart,
  isStartLineItemEmailSent,
}) => {
  const method = "PUT";
  const urlAPI = `/api/lineItems/${id}/workflow`;
  const body = {
    shouldSendEmailAtStart,
    isStartLineItemEmailSent,
  };

  return await fetchServer({ method, urlAPI, body });
};

export const updateLineItemValidStats = async ({
  id,
  hasValidStats,
  validStatsComment,
}) => {
  const method = "PUT";
  const urlAPI = `/api/lineItems/${id}/valid-stats`;
  const body = {
    hasValidStats,
    validStatsComment,
  };

  return await fetchServer({ method, urlAPI, body });
};

export const deleteLineItem = async (id) => {
  const method = "DELETE";
  const urlAPI = `/api/lineItems/${id}`;
  return await fetchServer({ method, urlAPI });
};

export const restoreLineItem = async (id) => {
  const method = "PUT";
  const urlAPI = `/api/lineItems/${id}/restore`;
  return await fetchServer({ method, urlAPI });
};

export const deleteLineItems = async (arrayIds) => {
  const method = "POST";
  const urlAPI = "/api/lineItems/delete-many";
  const body = arrayIds;
  return await fetchServer({ method, urlAPI, body });
};

export const restoreLineItems = async (arrayIds) => {
  const method = "POST";
  const urlAPI = "/api/lineItems/restore-many";
  const body = arrayIds;
  return await fetchServer({ method, urlAPI, body });
};
